<template>
  <div class="flex gap-4">
    <button
      @click="select('rejected')"
      class="p-2 rounded-md flex items-center justify-center gap-2 border-2 transition-colors"
      :class="
        modelValue === 'rejected'
          ? 'border-primary30 bg-primary30/10'
          : 'border-gray-200 bg-gray-100 hover:border-gray-300'
      "
    >
      <div
        class="w-4 h-4 rounded-full border-2 flex items-center justify-center bg-white"
        :class="modelValue === 'rejected' ? 'border-primary30' : 'border-gray-400'"
      >
        <div v-if="modelValue === 'rejected'" class="w-2 h-2 rounded-full bg-primary30"></div>
      </div>
      <span class="text-textPrimary text-sm">Reprovar</span>
    </button>

    <button
      @click="select('approved')"
      class="p-2 rounded-md flex items-center justify-center gap-2 border-2 transition-colors"
      :class="
        modelValue === 'approved'
          ? 'border-negative bg-negative/10'
          : 'border-gray-200 bg-gray-100 hover:border-gray-300'
      "
    >
      <div
        class="w-4 h-4 rounded-full border-2 flex items-center justify-center bg-white"
        :class="modelValue === 'approved' ? 'border-negative' : 'border-gray-400'"
      >
        <div v-if="modelValue === 'approved'" class="w-2 h-2 rounded-full bg-negative"></div>
      </div>
      <span class="text-textPrimary text-sm">Aprovar</span>
    </button>
  </div>
</template>

<script setup lang="ts">
type ApprovalStatus = 'approved' | 'rejected' | null

const props = defineProps<{
  modelValue: ApprovalStatus
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: ApprovalStatus): void
}>()

const select = (value: ApprovalStatus) => {
  const newValue = props.modelValue === value ? null : value
  emit('update:modelValue', newValue)
}
</script>
